/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { CardContent } from '../../../Shared/Card'
import { useTranslation } from 'react-i18next'

const NoTopProductsCardContent = () => {
    const [t] = useTranslation()

    return (
      <CardContent
        css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 3rem;
            color: #999;
            font-style: italic;
            padding: 1rem;
        `}
      >
          <div
            css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 1rem;
                text-align: center;
            `}
          >
            <Icon name='hourglass start' size='huge' />
              {t('dashboard.top_products.no_data')}
          </div>
      </CardContent>
    )
}

export { NoTopProductsCardContent }
